<form>
    <mat-form-field appearance="outline" class="org-search-select">
        <mat-label class="search-bar-label">
            Select Organization
        </mat-label>
        <input type="text" placeholder="Search.." matInput [formControl]="orgControl" [matAutocomplete]="auto"
            #searchKeyword>
        @if(!searchKeyword.value){
            <mat-icon matSuffix>search</mat-icon>
        }
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
            (optionSelected)="onOrganizationSelectEvent($event)">
            <mat-option *ngFor="let organization of filteredOrganizations | async" [value]="organization" [disabled]="loading.value">
                {{ organization.organization_name }}
            </mat-option>
        </mat-autocomplete>
        @if(searchKeyword.value) {
            <button type="button" matIconSuffix mat-icon-button aria-label="Clear" (click)="clearSearch(searchKeyword)">
                <mat-icon>close</mat-icon>
            </button>
        }
    </mat-form-field>
</form>